import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetAccountsForLead as GetAccountsForLeadQuery,
    GetAccountsForLead_lead_accounts as Accounts,
    GetAccountsForLeadVariables,
} from 'nutshell-graphql-types';

import GET_ACCOUNTS_FOR_LEAD from '../queries/get-accounts-for-lead.graphql';

export const useGetAccountsForLead = (
    leadId: string
): {
    accounts: Accounts | null | undefined;
    isLoading: boolean;
    error: string | null | undefined;
    refetch: () => Promise<any>;
} => {
    const {loading, data, error, refetch} = useQuery<
        GetAccountsForLeadQuery,
        GetAccountsForLeadVariables
    >(GET_ACCOUNTS_FOR_LEAD, {
        variables: {
            leadId,
        },
    });

    return {
        accounts: data && data.lead && data.lead.accounts,
        isLoading: loading,
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        refetch,
    };
};
